import { Formik } from 'formik';
import _ from 'lodash';
import pluralize from 'pluralize';
import React, { useRef } from 'react';
import * as Yup from 'yup';
import { FieldControl, FixedSingleSelect, Form } from '~/components';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';
import allocationBookingTypes from '~/lookups/allocation-booking-types';
import AllocationSummary from './AllocationSummary';

export default function BulkSetBookingType({ ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();
  const formRef = useRef();

  return (
    <BulkActionModal
      title="Bulk Set Booking Type"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() => formRef.current?.submitForm()}
      renderRow={AllocationSummary}>
      <Formik
        innerRef={formRef}
        initialValues={{ bookingTypeId: null }}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={Yup.object().shape({
          bookingTypeId: Yup.string().label('Booking Type').nullable().required(),
        })}
        onSubmit={(values) =>
          api.www
            .workspaces(workspace.id)
            .allocations()
            .bulkSetBookingType(ids, { bookingTypeId: values.bookingTypeId })
            .then((r) => r.data)
        }>
        {(formik) => (
          <Form>
            <p>
              Set the booking type of {ids.length} {pluralize('allocation', ids.length)} to:
            </p>

            <Form.Control>
              <FieldControl error={formik.submitCount > 0 && formik.errors.bookingTypeId}>
                <FixedSingleSelect
                  name="bookingTypeId"
                  placeholder="Booking Type"
                  materialPlaceholder={false}
                  value={formik.values.bookingTypeId || ''}
                  onChange={formik.handleChange}>
                  {_.map(allocationBookingTypes, (bookingType) => (
                    <option key={bookingType.id} value={bookingType.id}>
                      {bookingType.name}
                    </option>
                  ))}
                </FixedSingleSelect>
              </FieldControl>
            </Form.Control>
          </Form>
        )}
      </Formik>
    </BulkActionModal>
  );
}
